import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Opponents from '../../Opponents';

const LOCATION = 'location';
const ACTION = 'action';
const DEFAULT_OPTION_VALUE = 'EITHER';
const HOME_OPTION_VALUE = 'HOME';
const AWAY_OPTION_VALUE = 'AWAY';
const BATTING_OPTION_VALUE = 'BATTING';
const PITCHING_OPTION_VALUE = 'PITCHING';
const HOME_OPTION = {
    label: 'Home',
    value: HOME_OPTION_VALUE,
};
const AWAY_OPTION = {
    label: 'Away',
    value: AWAY_OPTION_VALUE,
};
const BATTING_OPTION = {
    label: 'Batting',
    value: BATTING_OPTION_VALUE,
};
const PITCHING_OPTION = {
    label: 'Pitching',
    value: PITCHING_OPTION_VALUE,
};
const EITHER_OPTION = {
    label: 'Either',
    value: DEFAULT_OPTION_VALUE,
};
const locationOptions = [
    HOME_OPTION,
    AWAY_OPTION,
    EITHER_OPTION,
];
const actionOptions = [
    BATTING_OPTION,
    PITCHING_OPTION,
    EITHER_OPTION,
];
const defaultParticipantState = {
    [LOCATION]: EITHER_OPTION,
    [ACTION]: EITHER_OPTION,
};
const modifiers = {
    [LOCATION]: locationOptions,
    [ACTION]: actionOptions,
};
const opposingModifiers = [
    LOCATION,
    ACTION,
];

const Teams = (props) => {

    const {
        componentConfig,
        fields,
        onChange,
    } = props;

    const {
        suggestionsKey = 'teams',
        placeholder = 'Select Team',
        typeaheadFieldId = 163,
        teamFieldId = 164,
        battingFieldId = 114,
        pitchingFieldId = 116,
        homeFieldId = 13,
        awayFieldId = 15,
    } = componentConfig;

    const {
        defaultField,
        modifierFieldMap,
        stateFieldMap,
    } = useMemo(() => {

        const defaultField = fields.find(field => Number(field.id) === teamFieldId);

        const modifierFieldMap = {
            [LOCATION]: {
                [DEFAULT_OPTION_VALUE]: defaultField,
                [HOME_OPTION_VALUE]: fields.find(field => Number(field.id) === homeFieldId),
                [AWAY_OPTION_VALUE]: fields.find(field => Number(field.id) === awayFieldId),
            },
            [ACTION]: {
                [DEFAULT_OPTION_VALUE]: defaultField,
                [BATTING_OPTION_VALUE]: fields.find(field => Number(field.id) === battingFieldId),
                [PITCHING_OPTION_VALUE]: fields.find(field => Number(field.id) === pitchingFieldId),
            },
        };

        const stateFieldMap = {
            [battingFieldId]: {
                stateProp: ACTION,
                option: BATTING_OPTION,
            },
            [pitchingFieldId]: {
                stateProp: ACTION,
                option: PITCHING_OPTION,
            },
            [homeFieldId]: {
                stateProp: LOCATION,
                option: HOME_OPTION,
            },
            [awayFieldId]: {
                stateProp: LOCATION,
                option: AWAY_OPTION,
            },
        };

        return {
            defaultField,
            modifierFieldMap,
            stateFieldMap,
        };

    });

    return (
        <Opponents
            defaultField={defaultField}
            defaultParticipantState={defaultParticipantState}
            defaultOptionValue={DEFAULT_OPTION_VALUE}
            modifierFieldMap={modifierFieldMap}
            modifiers={modifiers}
            opposingModifiers={opposingModifiers}
            stateFieldMap={stateFieldMap}
            suggestionsKey={suggestionsKey}
            placeholder={placeholder}
            typeaheadFieldId={typeaheadFieldId}
            onChange={onChange}
            componentConfig={componentConfig}
            fields={fields}
            topHeader={'Team 1'}
            bottomHeader={'Team 2'}
            removeOpponentLabel={'Remove Team 2'}
        />
    );

};

Teams.propTypes = {
    componentConfig: PropTypes.object.isRequired,
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            selected: PropTypes.array.isRequired,
        }).isRequired
    ).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default Teams;
